export const DEFAULT_TITLE = 'Map of Medical Residency and Fellowship Programs';

export const DETAILS_TAB = 1;
export const INFO_TAB = 2;
export const MAP_TAB = 3;

export const TAB = {
  DETAILS: DETAILS_TAB,
  INFO: INFO_TAB,
  MAP: MAP_TAB
};
